import React, { useState, useEffect } from "react";
import { Button, Modal, TextInput } from "@opendate-app/setlist";

const SavedRowOverlay = ({ config }) => {
  const { isOpen = false, args, resolve, reject } = config;

  const [name, setName] = useState("");

  useEffect(() => {
    if (isOpen) { setName(args?.metadata?.name || ""); }
  }, [isOpen, args?.metadata?.name]);

  const handleSave = () => {
    if (!isOpen) { return; }
    resolve({ name });
  };

  return (
    <Modal
      open={isOpen}
      onClose={reject}
      size="sm"
      title="Save row"
      footer={(
        <>
          <Button variant="secondary" onClick={reject}>Cancel</Button>
          <Button variant="primary" disabled={!name} onClick={handleSave}>Save</Button>
        </>
      )}
    >
      <TextInput
        aria-label="Row name"
        placeholder="Row name"
        value={name}
        onChange={(event) => setName(event.target.value)}
      />
    </Modal>
  );
};

export default SavedRowOverlay;
